export default "__VITE_PUBLIC_ASSET__76582a5b__"